import { useState, useRef, useCallback } from 'react';
import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { zohoAPI } from '../../lib/api';

export default function PreviewSyncButton() {
  const [syncing, setSyncing] = useState(false);
  const pollRef = useRef(null);

  const poll = useCallback(() => {
    pollRef.current = setInterval(async () => {
      try {
        const res = await zohoAPI.previewSyncStatus();
        if (!res.data.running) {
          clearInterval(pollRef.current);
          setSyncing(false);
          if (res.data.error) {
            toast.error(`Sync failed: ${res.data.error}`);
          } else if (res.data.result) {
            const r = res.data.result;
            toast.success(
              `Synced: ${r.items_synced} items, ${r.purchase_orders_synced} POs, ${r.sales_orders_synced} SOs in ${r.elapsed_display}`
            );
          }
        }
      } catch {
        clearInterval(pollRef.current);
        setSyncing(false);
      }
    }, 3000);
  }, []);

  const handleSync = async () => {
    setSyncing(true);
    try {
      await zohoAPI.startPreviewSync();
      poll();
    } catch (e) {
      setSyncing(false);
      if (e.response?.status === 409) {
        toast.error('Sync already running');
      } else {
        toast.error(e.response?.data?.detail || 'Failed to start sync');
      }
    }
  };

  return (
    <Button
      size="sm"
      variant="outline"
      className="h-8 text-xs rounded-sm gap-1.5"
      disabled={syncing}
      onClick={handleSync}
      data-testid="preview-manual-sync-btn"
    >
      <RefreshCw className={`h-3.5 w-3.5 ${syncing ? 'animate-spin' : ''}`} />
      {syncing ? 'Syncing…' : 'Sync from Zoho'}
    </Button>
  );
}
